import { type RefObject, useEffect } from 'react'

import {
  FEATURE_TOGGLE_FRIENDLY_CAPTCHA,
  useFeatureToggleContext,
} from '../../../feature-toggles'

export const useSkipFriendlyCaptcha = (
  doneCallbackRef?: RefObject<(solution: string) => unknown>,
): boolean => {
  const featureToggles = useFeatureToggleContext()
  const friendlyCaptchaToggleActive =
    featureToggles[FEATURE_TOGGLE_FRIENDLY_CAPTCHA]
  const skipFriendlyCaptchaLocal =
    process.env.NEXT_PUBLIC_SKIP_FRIENDLY_CAPTCHA === 'true' &&
    typeof window !== 'undefined' &&
    window.location.hostname === 'localhost'

  const skipFriendlyCaptcha =
    skipFriendlyCaptchaLocal || !friendlyCaptchaToggleActive

  useEffect(() => {
    if (skipFriendlyCaptcha && doneCallbackRef) {
      // Fake the doneCallback when captcha is skipped
      // value needs to be 'shop-apotheke' for automation since it's being validated in contact form submission: https://github.com/RedTecLab/contact-service/blob/77ca2f178780b9f6a6bcd7c7593860cdd8fb8ff3/src/validators/friendlyCaptchaValidation.ts#L29
      doneCallbackRef.current('shop-apotheke')
    }
  }, [skipFriendlyCaptcha, doneCallbackRef])

  return skipFriendlyCaptcha
}
